var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, useLocation, useParams } from "react-router-dom";
import Language from "../../../../../pages/moduleBuilder/studio/packages/languages";
import Fields from ".";
import ItemList from "@/components/studio/dropdown-editor/itemList";
import { useAppSelector } from "@/hooks/store";
import DropdownEditor from "@/pages/moduleBuilder/studio/lists/_list";
import DropdownList from "@/components/studio/dropdown-editor/dropdownList";
import { Relationships } from "@/pages/moduleBuilder/studio/packages/relationships";
import { Layouts } from "@/pages/moduleBuilder/studio/packages/layouts";
import Subpanels from "@/pages/moduleBuilder/studio/packages/subpanels";
import { useTranslation } from "react-i18next";
import ExportCustom from "@/pages/moduleBuilder/exportCustom";
export default function Content() {
    var location = useLocation();
    var t = useTranslation(["common", "Administration", "ModuleBuilder"]).t;
    var path = location.pathname.split("/");
    var indiceRoot = 4;
    var packages_list = useAppSelector(function (state) { return state.moduleBuilder.studio_packages; });
    var dropdowns_list = useAppSelector(function (state) { return state.moduleBuilder.studio_dropdowns; });
    var _a = useParams(), packagesName = _a.packagesName, moduleName = _a.moduleName, type = _a.type, menu = _a.menu, dropdownName = _a.dropdownName;
    var mbRoot = "/modules/ModuleBuilder";
    var submenus = [
        {
            name: "fields",
            label: t("LBL_FIELDS", { ns: "ModuleBuilder" }),
            description: t("LBL_FIELDS_DESCRIPTION", { ns: "ModuleBuilder" }),
        },
        {
            name: "languages",
            label: t("LBL_LANGUAGES", { ns: "ModuleBuilder" }),
            description: t("LBL_LANGUAGES_DESCRIPTION", { ns: "ModuleBuilder" }),
        },
        {
            name: "layouts",
            label: t("LBL_LAYOUTS", { ns: "ModuleBuilder" }),
            description: t("LBL_LAYOUTS_DESCRIPTION", { ns: "ModuleBuilder" }),
        },
        {
            name: "relationships",
            label: t("LBL_RELATIONSHIPS", { ns: "ModuleBuilder" }),
            description: t("LBL_RELATIONSHIPS_DESCRIPTION", { ns: "ModuleBuilder" }),
        },
        {
            name: "subpanels",
            label: t("LBL_SUBPANELS", { ns: "ModuleBuilder" }),
            description: t("LBL_SUBPANELS_DESCRIPTION", { ns: "ModuleBuilder" }),
        },
    ];
    var action_content = function () {
        switch (menu) {
            case "fields":
                return _jsx(Fields, {});
            case "languages":
                return _jsx(Language, {});
            case "layouts":
                return _jsx(Layouts, {});
            case "relationships":
                return (_jsx("div", { children: _jsx(Relationships, {}) }, "relationship_".concat(Date.now())));
            case "subpanels":
                return _jsx(Subpanels, {});
            default:
                return _jsxs(_Fragment, { children: ["EDITION - ", menu] });
        }
    };
    var content = (_jsx("div", __assign({ className: "col-span-10" }, { children: menu ? (action_content()) : (_jsx("div", __assign({ className: "mt-14 w-full flex flex-wrap gap-4 max-h-[45vh] overflow-auto" }, { children: submenus.map(function (menu, index) { return (_jsxs("div", __assign({ className: "w-1/5 bg-white shadow-md rounded-sm p-4 m-4 " }, { children: [_jsx("header", __assign({ className: "text-lg font-semibold" }, { children: menu.label })), _jsx("hr", { className: "my-2 border-t " }), _jsx("div", __assign({ className: "my-2 overflow-y-auto py-4" }, { children: menu.description })), _jsx("hr", { className: "my-2 border-t" }), _jsx("footer", __assign({ className: "mt-2" }, { children: _jsx(Link, __assign({ className: "text-blue-500 hover:text-blue-700", to: "".concat(mbRoot, "/").concat(type, "/packages/").concat(packagesName, "/").concat(moduleName, "/").concat(menu.name) }, { children: t("LBL_EDIT", { ns: "ModuleBuilder" }) })) }))] }), index)); }) }))) })));
    return (_jsx(_Fragment, { children: path[path.length - 1] !== "lists" ? (dropdownName === undefined ? (path.length === indiceRoot ? (_jsx(_Fragment, {})) : moduleName ? (content) : packagesName === undefined ? (_jsx("div", __assign({ className: " overflow-x-auto max-h-[60vh]" }, { children: _jsx(ItemList, { item: packages_list }) }), "package")) : packagesName === "exportCustomizations" ? (_jsx("div", __assign({ className: "" }, { children: _jsx(ExportCustom, {}) }), "package")) : (_jsx("div", __assign({ className: " overflow-x-auto max-h-[60vh]" }, { children: _jsx(ItemList, { item: packages_list }) }), "module"))) : (_jsx(DropdownEditor, {}))) : (_jsx(DropdownList, { item: dropdowns_list })) }));
}
